import React from "react";

export type ManageDocketTemplateFilterRootContextType = {
  index?: number;
};

export const ManageDocketTemplateFilterRootContext = React.createContext<
  ManageDocketTemplateFilterRootContextType | undefined
>(undefined);
